import { KeycloakOptions, KeycloakService } from 'keycloak-angular';
import { MAIN_NAVIGATION_CONFIG } from 'libs/design-system/src/lib/components/main-navigation/main-navigation.config';

import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';
import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { ANALYTICS_CONFIG, CommonsModule, loadingOverlayInterceptorProvider, monitoringInterceptorProvider } from '@peca/commons';
import { DesignSystemModule, InsightsService } from '@peca/design-system';
import { KeycloakCredentialsService, keycloakHttpInterceptorProvider, keyclockProviderFactory } from '@peca/keycloak';

import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { ConfirmableActionComponent } from './core/components/confirmable-action/confirmable-action.component';
import { menu } from './core/menu.config';
import { ROLE_MAP, ROLE_MAP_CONFIG } from './core/roles.config';
import { ConfirmableActionService } from './core/services/confirmable-action.service';

registerLocaleData(pt);

@NgModule({
  declarations: [AppComponent, ConfirmableActionComponent],
  imports: [BrowserModule, RouterModule.forRoot(routes, { initialNavigation: 'enabledBlocking' }), BrowserAnimationsModule, CommonsModule, DesignSystemModule],
  providers: [
    { provide: ROLE_MAP_CONFIG, useValue: ROLE_MAP },
    { provide: MAIN_NAVIGATION_CONFIG, useValue: { ...menu, production: environment.production } },
    { provide: ANALYTICS_CONFIG, useValue: environment.mixpanel },
    { provide: LOCALE_ID, useValue: 'pt' },
    keyclockProviderFactory(environment.keycloak as KeycloakOptions),
    monitoringInterceptorProvider,
    loadingOverlayInterceptorProvider,
    KeycloakService,
    KeycloakCredentialsService,
    keycloakHttpInterceptorProvider,
    ConfirmableActionService,
    InsightsService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
